import { render, staticRenderFns } from "./VatDeclarationsView.vue?vue&type=template&id=0edb91de&"
import script from "./VatDeclarationsView.vue?vue&type=script&lang=js&"
export * from "./VatDeclarationsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports